import api from '../../api/case-categories';
import {filter, chain, includes} from 'lodash';

export default {
    state: {
        list: [],
    },

    mutations: {
        setCategories(state, data) {
            state.list = chain(state.list).concat(data).uniqBy('id').value();
        },
    },

    actions: {
        fetchModuleData() {

        },

        fetchCaseCategories({commit, state}) {
            api.request().then((response) => {
                commit('setCategories', response.data);
            });
        },
    },

    getters: {
        getCaseCategories(state) {
            return () => {
                return state.list;
            };
        },

        getCaseCategoriesByIds(state) {
            return (ids) => {
                return filter(state.list, function(item) {
                    return includes(ids, item.id);
                });
            };
        },
    },
};